// De cual de los DOS MUNDOS es este partido.
//
// El club vive dos competencias distintas y la agenda las juntaba sin decirlo:
//
//   TORNEO INTERNO -- el organizador NO esta en MYKLUBB. El club captura todo: crea el
//   torneo, inscribe sus grupos, programa los juegos y pone los marcadores.
//
//   MYKLUBB TORNEOS -- la organizadora si esta en la red y lleva el rol oficial. El club
//   ve sus partidos, les toma asistencia e imprime su tarjeton, pero NO los edita.
//
// Las dos tarjetas se veian iguales. Lo unico que las distinguia era que a una le
// faltaba el menu de acciones -- en silencio, sin decir por que. Este modulo le da
// nombre a la diferencia para que la pantalla pueda mostrarla y filtrar por ella.
//
// El mundo lo define el TORNEO, no el partido. Un partido heredado sin `torneo_juego_id`
// dentro de un torneo de la red sigue siendo de la red; quien manda es de quien es la
// competencia.

import { esTorneoExterno, clubCapturaEsteTorneo } from './torneoOrigen'

export const MUNDO_INTERNO = 'internos'
export const MUNDO_RED = 'red'
export const MUNDO_TODOS = 'todos'

// El torneo cuelga del juego con dos nombres segun de donde venga el join.
const torneoDe = (juego) => juego?.torneo || juego?.torneos || null

// Devuelve null -- no 'internos' -- cuando no se puede saber: sin la org del usuario, o
// con un torneo al que la consulta no le pidio la organizadora. Contestar 'internos'
// ahi seria inventar. (Un torneo sin organizadora ya no existe en la base; si llega
// asi, falta el campo en el select.)
export const mundoDelTorneo = (torneo, orgId) => {
  if (!torneo || !orgId) return null
  if (esTorneoExterno(torneo, orgId)) return MUNDO_RED
  if (clubCapturaEsteTorneo(torneo, orgId)) return MUNDO_INTERNO
  return null
}

// El partido hereda el mundo de su torneo, sin excepcion.
export const mundoDelJuego = (juego, orgId) => {
  if (!juego) return null
  return mundoDelTorneo(torneoDe(juego), orgId)
}

// Sin orgId no se filtra NADA. Preferimos mostrar de mas un instante -- mientras carga
// la organizacion -- que esconder los partidos del dia sin poder justificar cuales.
export const filtrarPorMundo = (juegos, mundo, orgId) => {
  const lista = juegos || []
  if (mundo === MUNDO_TODOS || !orgId) return lista
  return lista.filter((juego) => mundoDelJuego(juego, orgId) === mundo)
}

// Una lista de TORNEOS (no de partidos) repartida en sus dos casas, para pintarlas como
// dos secciones y no como una lista con distintivo. `sinMundo` son los que no se pueden
// clasificar todavia (la org no cargo, o a la fila le falta la organizadora): no se
// esconden ni se inventa su casa; la pantalla decide donde ensenarlos mientras tanto.
export const partirPorMundo = (torneos, orgId) => {
  const partes = { [MUNDO_INTERNO]: [], [MUNDO_RED]: [], sinMundo: [] }
  ;(torneos || []).forEach((torneo) => {
    if (!torneo) return
    const mundo = mundoDelTorneo(torneo, orgId)
    if (mundo) partes[mundo].push(torneo)
    else partes.sinMundo.push(torneo)
  })
  return partes
}

// Para los rotulos del interruptor: cuantos hay de cada lado.
export const contarPorMundo = (juegos, orgId) => {
  const lista = juegos || []
  const conteo = { [MUNDO_INTERNO]: 0, [MUNDO_RED]: 0, [MUNDO_TODOS]: lista.length }
  if (!orgId) return conteo
  lista.forEach((juego) => {
    const mundo = mundoDelJuego(juego, orgId)
    if (mundo) conteo[mundo] += 1
  })
  return conteo
}

// ¿Tiene sentido ofrecer "Crear juego" con este mundo puesto?
//
// En MYKLUBB Torneos el rol lo baja la organizadora y el trigger `_juegos_guard` rechaza
// la escritura, asi que el boton ahi no promete nada. En "Todos" si: la agenda muestra los
// dos, pero crear sigue siendo posible -- en un torneo interno, que es lo unico que el
// formulario ofrece.
//
// El boton listaba bien (solo internos) pero vivia en la unica pantalla que cruza los dos
// mundos, sin decir que la lista venia filtrada. Se leia como mezcla.
export const seCreaEnEsteMundo = (mundo) => mundo !== MUNDO_RED
